module.exports = __webpack_public_path__ + "assets/img/main-logo_mobile-chengde.6f0c7ae9.png";